import { AdminAccountEditAutomationTemplate } from '../../../web/containers/EditAutomationTemplate/AdminAccountEditAutomationTemplate';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';

export const AdminAccountEditAutomationPage = () => {
	return (
		<AdminDashboardPageLayout>
			<AdminAccountEditAutomationTemplate />
		</AdminDashboardPageLayout>
	);
};
